import { Button, HStack } from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { SINGLE_LEAD_STRIP_ID } from './SingleLeadPlot';
import { TagButton } from './TagButton';
import { DELINEATION_NOISE_TAGS } from '../../wave/utils/tags.utils';
import { noiseTagFilterSelector } from '../selectors/strip.selectors';
import * as stripActions from '../../plot/actions/strip.actions';
import { useMemo } from 'react';

export const TagFilter = () => {
  const dispatch = useDispatch();
  const selectedTagFilter = useSelector(
    noiseTagFilterSelector(SINGLE_LEAD_STRIP_ID),
  );
  const tags = useMemo(
    () => DELINEATION_NOISE_TAGS.sort((a, b) => a.priority - b.priority),
    [],
  );
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    dispatch(
      stripActions.update({
        stripId: SINGLE_LEAD_STRIP_ID,
        strip: {
          noiseTagFilter: undefined,
        },
      }),
    );
  };

  return (
    <HStack spacing='s' pt='s' pl='s'>
      {tags.map((tag) => (
        <TagButton key={tag.name} tag={tag} />
      ))}
      <Button
        variant='secondary'
        size='xs'
        isActive={selectedTagFilter == null}
        fontSize='.8rem'
        onClick={handleClick}
      >
        All
      </Button>
    </HStack>
  );
};
